import { render, staticRenderFns } from "./ScoreQuery.vue?vue&type=template&id=57ae5e2d&scoped=true"
import script from "./ScoreQuery.vue?vue&type=script&lang=js"
export * from "./ScoreQuery.vue?vue&type=script&lang=js"
import style0 from "./ScoreQuery.vue?vue&type=style&index=0&id=57ae5e2d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ae5e2d",
  null
  
)

export default component.exports